export const basePath = '/qa'

export const routes = {
  root: basePath,
  create: `${basePath}/create`,
  edit: (uid: string) => `${basePath}/edit/${uid}`,
}
